import React, { useLayoutEffect, useState } from 'react';

import { ItemGroupProps } from 'types/ItemGroupProps';
import Carousel from 'components/Carousel';
import { CarouselImagesProps } from 'types/CarouselImagesProps';
import * as S from './styles';

interface BannersCarouselProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function BannersCarousel({ data }: BannersCarouselProps) {
  const [arrayImages, setArrayImages] = useState<
    { id: number; imageUrl: string }[] | []
  >([]);

  useLayoutEffect(() => {
    if (data.items.length > 0) {
      const images: CarouselImagesProps[] = [];

      data.items.forEach(item => {
        if (item?.file?.url && item?.id) {
          images.push({ id: item.id, imageUrl: item.file.url });
        }
      });

      if (images.length > 0) {
        setArrayImages(images);
      }
    }
  }, []);

  return (
    <S.container>
      {arrayImages.length === 0 ? (
        <S.centralizeNotice>
          <p>Não há banners</p>
        </S.centralizeNotice>
      ) : (
        <Carousel items={arrayImages} isBtns={false} objectFitImg="fill" />
      )}
    </S.container>
  );
}
